import { Box, Button, ButtonGroup, PrimaryButton } from "@nulogy/components";
import ConfirmModalContext from "contexts/ConfirmModalContext";
import React, { useContext } from "react";
import Modal from "./Modal";

export default function ConfirmModal() {
  const { handleConfirm, handleCancel, message, isOpen, primaryButtonText, title } = useContext(ConfirmModalContext);
  const messageIsInnerHtml = typeof message === "string";

  const footerContent = (
    <ButtonGroup>
      <PrimaryButton className="spec-confirm-modal-ok" onClick={handleConfirm}>
        {primaryButtonText}
      </PrimaryButton>
      <Button onClick={handleCancel}>Cancel</Button>
    </ButtonGroup>
  );

  return (
    <Modal ariaHideApp={false} footerContent={footerContent} isOpen={isOpen} title={title}>
      <Box>
        {/* biome-ignore lint/security/noDangerouslySetInnerHtml: message·came·as·an·html·string */}
        {messageIsInnerHtml && <div dangerouslySetInnerHTML={{ __html: message }} />}
        {!messageIsInnerHtml && message}
      </Box>
    </Modal>
  );
}
